import { createSlice } from "@reduxjs/toolkit";
import { constants } from "@qgiv/core-js";
import {
    hasParentRegistration,
    appSettings as initialState,
} from "../initialState";

const { cms } = constants;

const isCms = cms === "1";

const getInitialState = () => ({
    // BE is sending formStatus back inside appSettings
    ...initialState,
    appLoading: true,
    payPal: {
        hasCompletedPayPalAuthorizationFlow: false,
        hasInitiatedPayPalAuthorizationFlow: false,
        paymentMethodResetCount: 0,
        payPalPaymentSource: "paypal",
    },
    shouldDisplayApplePay: false,
    showRegistrationRole: isCms,
    showRemainingForm: isCms,
    teamModalOpen: false,
    emailModalOpen: false,
    hasParentRegistration,
    hasLoadedFirstRegistrationPage: false,
    hasSubmittedRegistration: false,
});

const slice = createSlice({
    name: "appSettings",
    initialState: getInitialState(),
    reducers: {
        setAppLoading: (state, action) => {
            state.appLoading = action.payload;
        },
        setAppShowRemainingForm: (state, action) => {
            // We should never hide the remaining form in CMS
            state.showRemainingForm = isCms || action.payload;
        },
        setAppHasSubmittedRegistration: (state, action) => {
            state.hasSubmittedRegistration = action.payload;
        },
        setAppTeamModalOpen: (state, action) => {
            state.teamModalOpen = action.payload;
        },
        setAppEmailModalOpen: (state, action) => {
            state.emailModalOpen = action.payload;
        },
        setAppShowRegistrationRole: (state, action) => {
            // We should never hide the registration roles in CMS
            state.showRegistrationRole = isCms || action.payload;
        },
        setAppHasLoadedFirstRegistrationPage: (state, action) => {
            state.hasLoadedFirstRegistrationPage = action.payload;
        },

        // Digital Wallets
        incrementPaymentMethodResetCount: (state) => {
            state.payPal.paymentMethodResetCount += 1;
        },
        setPayPalPaymentSource: (state, action) => {
            state.payPal.payPalPaymentSource = action.payload;
        },
        setHasCompletedPayPalAuthorizationFlow: (state, action) => {
            state.payPal.hasCompletedPayPalAuthorizationFlow = action.payload;
        },
        setHasInitiatedPayPalAuthorizationFlow: (state, action) => {
            state.payPal.hasInitiatedPayPalAuthorizationFlow = action.payload;
        },
        setShouldDisplayApplePay: (state, action) => {
            state.shouldDisplayApplePay = action.payload;
        },
    },
});

// actions
export const {
    incrementPaymentMethodResetCount,
    setAppLoading,
    setPayPalPaymentSource,
    setShouldDisplayApplePay,
    setAppShowRegistrationRole,
    setHasCompletedPayPalAuthorizationFlow,
    setHasInitiatedPayPalAuthorizationFlow,
    setAppHasLoadedFirstRegistrationPage,
    setAppShowRemainingForm,
    setAppHasSubmittedRegistration,
    setAppTeamModalOpen,
    setAppEmailModalOpen,
} = slice.actions;

// selectors
export const selectAppSettings = (state) => state.appSettings;

export const selectAppLoading = (state) => state.appSettings.appLoading;

export const selectPayPal = (state) => state.appSettings.payPal;

export const selectShouldDisplayApplePay = (state) =>
    state.appSettings.shouldDisplayApplePay;

export const selectShowRemainingForm = (state) =>
    state.appSettings.showRemainingForm;

export const selectTeamModalOpen = (state) => state.appSettings.teamModalOpen;

export const selectHasParentRegistration = (state) =>
    state.appSettings.hasParentRegistration;

export const selectFormStatus = (state) => state.appSettings.formStatus;

export default slice.reducer;
